import { useLocation } from "react-router-dom";
import Link from '@mui/joy/Link';
import HomeIcon from '@mui/icons-material/Home';
import Breadcrumbs from '@mui/joy/Breadcrumbs';

const History = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split("/").filter(segment => segment);

    return (
        <Breadcrumbs sx={{ p: 0}} >
            <Link sx={{ color: (theme) => theme.palette.mode === 'dark' ? theme.palette.neutral[300] : theme.palette.neutral[500] }} href='/app/tasks'>
                <HomeIcon fontSize='sm' />
            </Link>
            {pathSegments.map((segment, index) => {
                const segmentPath = `/${pathSegments.slice(0, index + 1).join("/")}`;

                return (
                    <Link key={segment} sx={{ color: (theme) => theme.palette.mode === 'dark' ? theme.palette.neutral[300] : theme.palette.neutral[500] }} href={segmentPath}>
                        {segment.charAt(0).toUpperCase() + segment.slice(1)}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
}

export default History;